import { Backdrop, Box, CircularProgress, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

const ReportLoadingOverlay = ({ open, reportName, period, detail }) => (
  <Backdrop
    open={open}
    sx={{
      zIndex: (theme) => theme.zIndex.modal + 10,
      bgcolor: "rgba(15, 23, 42, .72)",
      backdropFilter: "blur(5px)",
      px: 2,
    }}
  >
    <Paper
      elevation={18}
      role="status"
      aria-live="polite"
      sx={{
        width: "100%",
        maxWidth: 460,
        overflow: "hidden",
        borderRadius: "20px",
        textAlign: "center",
      }}
    >
      <Box sx={{ p: { xs: 3, sm: 4 } }}>
        <Box sx={{ position: "relative", width: 78, height: 78, mx: "auto", mb: 2.5 }}>
          <CircularProgress size={78} thickness={3.2} sx={{ color: "#6366f1" }} />
          <Box sx={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", color: "#6366f1" }}>
            <AssessmentOutlinedIcon sx={{ fontSize: 31 }} />
          </Box>
        </Box>
        <Typography fontSize={{ xs: 20, sm: 23 }} fontWeight={900}>
          Generating {reportName}
        </Typography>
        <Typography mt={0.75} color="text.secondary" fontWeight={700}>
          {period}
        </Typography>
        {detail && <Typography mt={0.5} color="text.secondary" fontSize={13}>{detail}</Typography>}
        <Stack spacing={0.6} mt={2.5}>
          <Typography color="text.secondary" fontSize={12.5}>
            Retrieving financial data and calculating report totals…
          </Typography>
          <Typography color="text.secondary" fontSize={11.5}>
            This may take a few moments. Please keep this page open.
          </Typography>
        </Stack>
      </Box>
      <LinearProgress sx={{ height: 6, bgcolor: "#e0e7ff", "& .MuiLinearProgress-bar": { bgcolor: "#6366f1" } }} />
    </Paper>
  </Backdrop>
);

export default ReportLoadingOverlay;
